import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-tooltip',
	templateUrl:'./WaTooltipPage.html',
	styles: [],
	styleUrls:['./WaTooltipPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaTooltipPage
{
	mdContent_478 = `\`\`\`java
import com.jwebmp.webawesome.components.tooltip.WaTooltip;
\`\`\``;
	mdContent_479 = `\`\`\`java
var btn = new WaButton<>("Hover me", Variant.Brand);
btn.setID("my-btn");
var tip = new WaTooltip<>();
tip.setForId("my-btn");
tip.setText("Click to save");
\`\`\``;
}
